import { Headphones, ShieldCheck, Truck, PoundSterling } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import FormReviewCompanion from "@/components/FormReviewCompanion";

const TRUST_POINTS = [
  { icon: Headphones, label: "UK-based human support" },
  { icon: PoundSterling, label: "Transparent pricing, no surprises" },
  { icon: Truck, label: "Order by 2pm for next-working-day setup" },
  { icon: ShieldCheck, label: "We handle switching end to end" },
];

/**
 * Final CTA: trust reassurance precedes the form (trust-before-form
 * sequencing), then ContactForm + review companion. The "not sure?"
 * guidance block routes undecided visitors to the hub instead of
 * abandoning.
 */
export default function ProductFinalCTA({ product }) {
  return (
    <section id="enquire" className="py-20 md:py-28 bg-white" data-testid={`${product.slug}-final-cta`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="font-heading text-3xl font-bold text-brand-black tracking-tight mb-6">
              {product.schemaType === "Product"
                ? `Get the ${product.name} with CanDo`
                : "Compare your options with CanDo"}
            </h2>
            <p className="text-sm leading-relaxed text-brand-grey mb-8">
              {product.schemaType === "Product"
                ? `Tell us a little about your business and we'll confirm pricing for the ${product.name}, check it's genuinely the right fit, and handle setup and switching for you.`
                : "Send us your current numbers and we'll give you an honest side-by-side of what a reader and a dedicated card machine would cost your business — no obligation."}
            </p>
            <ul className="space-y-4 mb-8">
              {TRUST_POINTS.map((t) => (
                <li key={t.label} className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-brand-aqua-light flex items-center justify-center flex-shrink-0">
                    <t.icon size={17} className="text-brand-aqua" aria-hidden="true" />
                  </div>
                  <span className="text-sm font-semibold text-brand-black">{t.label}</span>
                </li>
              ))}
            </ul>
            <div className="bg-gray-50 border border-brand-light-grey rounded-2xl p-5">
              <p className="text-sm font-semibold text-brand-black mb-1">Not sure which terminal is right?</p>
              <p className="text-sm text-brand-grey">
                Tell us how and where you take payments in the form — we'll recommend the best fit across our range, even if it isn't this one.
              </p>
            </div>
          </div>
          <div className="space-y-5">
            <div className="bg-white border border-brand-light-grey rounded-2xl p-6 sm:p-8 shadow-sm">
              <h3 className="font-heading text-xl font-bold text-brand-black mb-4">
                {product.schemaType === "Product" ? `Enquire about the ${product.name}` : "Get an honest comparison"}
              </h3>
              <ContactForm
                product={product.name}
                category="card-machines"
                source={`product-page-${product.slug}`}
              />
            </div>
            <FormReviewCompanion product="card-machines" testId={`${product.slug}-form-review`} />
          </div>
        </div>
      </div>
    </section>
  );
}
